import { useState } from 'react';

export default function usePagination(pageSize: number, initialPage = 1) {
  const [currentPage, setCurrentPage] = useState(initialPage);

  return {
    currentPage,
    setCurrentPage,
    skip: pageSize ? Math.max(0, (currentPage - 1) * pageSize) : 0,
  };
}
